import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { MainState } from './state';

const defaultState: MainState = {
  isLoggedIn: null,
  token: '',
  lang: localStorage.getItem('lang') || 'en',
  logInError: false,
  userProfile: null,
  dashboardMiniDrawer: false,
  dashboardShowDrawer: true,
  notifications: [],
  showProgress: false,
  version: null,
  config: {
    messagesStatsUrl: '',
    messagesApiUrl: '',
    authApiUrl: '',
  },
};

export const mainModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
